import { render, staticRenderFns } from "./Pagenotfound.vue?vue&type=template&id=9d074156&"
import script from "./Pagenotfound.vue?vue&type=script&lang=js&"
export * from "./Pagenotfound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports